import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import authActions from '../../redux/auth/actions';
import userActions from '../../redux/user/actions';
import globalActions from '../../redux/global/actions';
import Sidebar from '../../components/DashboardSidebar';
import Header from '../../components/DashboardHeader';
import './SidebarContainer.scss';

class SidebarContainer extends PureComponent {
  componentDidMount() {
    if (!this.props.dealers.length) {
      this.props.actions.currentUserDealersRequest();
    }
  }
  render() {
    const {
      actions,
      user,
      dealers,
      title,
      logo,
      sidebarOpened,
      children,
      openSubMenu,
      currentUserDealer,
    } = this.props;
    return (
      <div className="sidebar-container">
        <Sidebar
          user={user}
          opened={sidebarOpened}
          toggle={actions.toggleSidebar}
          openSubMenu={openSubMenu}
          currentUserDealer={currentUserDealer}
        />
        <div className="sidebar-content">
          <Header
            user={user}
            dealers={dealers}
            title={title}
            logo={logo}
            sidebarOpened={sidebarOpened}
            logout={actions.logoutRequest}
            accessDealerRequest={actions.accessDealerRequest}
            toggleSidebar={actions.toggleSidebar}
          />
          {children}
        </div>
      </div>
    );
  }
}

SidebarContainer.propTypes = {
  user: PropTypes.object,
  currentUserDealer: PropTypes.object,
  dealers: PropTypes.array,
  actions: PropTypes.object,
  sidebarOpened: PropTypes.bool,
  children: PropTypes.node,
  title: PropTypes.string,
  logo: PropTypes.string,
  openSubMenu: PropTypes.string,
};

SidebarContainer.defaultProps = {
  title: 'Manager Dashboard',
};

const mapStateToProps = ({ user, global }) => ({
  user: user.currentUser,
  dealers: user.currentUserDealers,
  sidebarOpened: global.sidebarOpened,
  currentUserDealer: user.currentUserDealer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...authActions,
      ...userActions,
      ...globalActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarContainer);
